import { Component, OnInit ,ViewContainerRef} from '@angular/core';
import { Http, Response } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import 'rxjs/Rx';
import 'rxjs/add/operator/map';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { LoginService } from '../Services/LoginService';



@Component({
  selector: 'app-login',
  templateUrl: '../Login/Login.component.html',
  styleUrls: ['../../Content/css/bootstrap.css', '../../Content/css/Login.css', '../../Content/css/master.css'],
  providers: [LoginService]
})
export class LoginComponent implements OnInit {
  title = 'Login';
  model: any = {};
  ImageUrl: any = "../../assets/images/Login.png";
  display: string = "none";
  ResetPwd: string = "none";

  constructor(private http: Http, private _LoginService: LoginService, private router: Router,
    public toastr: ToastsManager, vcr: ViewContainerRef)
  { this.toastr.setRootViewContainerRef(vcr); }
  ngOnInit() { }
  login() {
    var CheckStatus = true;
    if (this.model.Username == null || this.model.Username == "") {
      this.toastr.warning('Username can not be blank.');
      CheckStatus = false;
      return;
    }
    if (this.model.Password == null || this.model.Password == "") {
      this.toastr.warning('Password can not be blank.');
      CheckStatus = false;
      return;
    }
    this._LoginService.getTempPass(this.model).subscribe(res => {
      var data = res;
      if (data.length == 0) {
        this.toastr.error("Please enter the correct Username and Password");
        return;
      }
      if (data[0].PwdChangeStatus == "No") {
        CheckStatus = false;
        this.ResetPwd = "block";
      }
      else {
        this._LoginService.login(this.model).subscribe(res => {
          var data = res;
          if (data.length != 0) {
            sessionStorage.setItem('UserName', data[0].username);
            sessionStorage.setItem('RoleID', data[0].Role);
            sessionStorage.setItem('BCCEmail', data[0].Email);
            this.router.navigate(['/Dashboard']);
            this.model = {};
          }
          else {
            this.toastr.error("Please enter valid Username and  Password");
            this.model = {};
          }
        });
      }
    });

  }
  ResetPassword() {
    if (this.model.Username == null || this.model.Username == "") {
      this.toastr.error('Username can not be blank.')
    }
    else {
      this.display = "block";
    }
  }
  HideForgotPwdPopUp() {
    this.display = "none";
  }
  SendResetPassword() {
    this._LoginService.ResetPassword(this.model).subscribe(res => {
      var data = res;
      if (data.length == 0) {
        this.toastr.error("Invalid Username");
      }
      else
      { 
        this._LoginService.UpdateResetPassword(this.model).subscribe(res => {
          var data = res;
          this.model = {};
          this.display = "none";
          this.toastr.success('Your password has been reset and sent to following email' + ' ' + data[0].Email);
        });
      }
     });
  }
  HidePwdPopUp() {
    this.ResetPwd = "none";
  }
  SaveChangePwd() {
    if (this.model.OldPassword == null || this.model.OldPassword == "") {
      this.toastr.error('Old Password can not be blank.');
      return;
    }
    if (this.model.NewPassword == null || this.model.NewPassword == "") {
      this.toastr.error('New Password can not be blank.');
      return;
    }
    if (this.model.Confirmpassword == null || this.model.Confirmpassword == "") {
      this.toastr.error('Confirm Password can not be blank.');
      return;
    }
    if (this.model.NewPassword != this.model.Confirmpassword) {
      this.toastr.error('New Password and Repeat New Password do not match. Please retype.');
      return;
    }
    this.model.Password = this.model.Confirmpassword;
    var checkpass = this.IsPasswordValid(this.model.Password);
    if (checkpass == true) {
      this._LoginService.UpdatePassword(this.model).subscribe(res => {
        var data = res;
        if (data[0].message != 'Invalid Old Password' && data[0].message !='New Password must be different than the old password') {
          sessionStorage.setItem('UserName', data[0].username);
          sessionStorage.setItem('RoleID', data[0].Role);
          sessionStorage.setItem('BCCEmail', data[0].Email);
          this.ResetPwd = "none";
          this.router.navigate(['/Dashboard']);
          this.ResetPwd = "none";
          this.model = {};
        }
        else {
          this.toastr.error(data[0].message);
        }
      });
    }
  
  }

  IsPasswordValid(value) {

    if ((value.length < 5) || (value.length > 15)) {
      this.toastr.warning(" Length of new password should be 5 to 15 characters.");
      return false;
    }

    var validAlpha = (/[a-z]{3}/i.test(value));
    var validDigit = (/[0-9]/i.test(value));
    var validSpecial = false;
    var iChars = ".,?!:;-()[]";

    

    for (var i = 0; i < value.length; i++) {
      if (iChars.indexOf(value.charAt(i)) != -1) {
        validSpecial = true;
        break;
      }
    }

    if ((validAlpha != true) || (validDigit != true) || (validSpecial != true)) {
        this.toastr.warning('A valid password should contain at least 3 letters, 1 number and 1 punctuation.');
      return false;
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/Login/Login.component.ts